import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import Card from '@material-ui/core/Card';
import { createMuiTheme } from 'app-modules/application/styles/createMuiTheme';
import { messageItemHeight } from 'app-modules/chat/constants/sizes';
import {
  DESKTOP_GUIDE_WIDTH,
  FOOTER_HEIGHT_MOBILE,
  HEADER_HEIGHT,
} from 'app-modules/base/constants';
import { TriviaForm } from '../containers/Form';
import { TriviaResult } from '../containers/Result';
import { TriviaLeaderboard } from '../containers/Leaderboard';

const animationSpeed = '150ms';
const muiTheme = createMuiTheme('#000');

const styles = (theme) => ({
  close: {
    opacity: 0,
  },

  bg: {
    zIndex: 20,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    bottom: 0,
    boxSizing: 'border-box',
    color: '#FFFFFF',
    display: 'flex',
    padding: [[5, 5]],
    pointerEvents: 'none',
    position: 'absolute',
    transition: [['color', animationSpeed]],
    width: '100vw',

    [theme.breakpoints.down('sm')]: {
      // in sync with Watch/Layout.jsx
      height: `calc(100vh - 56.25vw - ${HEADER_HEIGHT}px - ${FOOTER_HEIGHT_MOBILE}px - ${messageItemHeight}px + 10px)`,
      bottom: FOOTER_HEIGHT_MOBILE,
    },

    [theme.breakpoints.up('md')]: {
      height: 'auto',
      width: DESKTOP_GUIDE_WIDTH,
      padding: theme.spacing.unit * 10,
      paddingTop: 0,
      paddingBottom: theme.spacing.unit * 5,
      bottom: 0,
      flexDirection: 'column-reverse',
      transition: 'opacity 200ms',
    },
  },

  isNotFullScreen: {
    zIndex: -1,
  },

  card: {
    minWidth: 275,
    pointerEvents: 'all',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
  },

  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
});

class Trivia extends PureComponent {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLeaderboardVisible: PropTypes.bool.isRequired,
    isAnswered: PropTypes.bool.isRequired,
    revealAnswer: PropTypes.bool.isRequired,
    playerIsFullscreen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  handleClose = (e) => {
    e.stopPropagation();
    this.props.onClose();
  };

  render() {
    const {
      classes,
      isVisible,
      isLeaderboardVisible,
      isAnswered,
      revealAnswer,
      playerIsFullscreen,
    } = this.props;
    const hideTrivia = !playerIsFullscreen || !isVisible;

    let TriviaCardComponent = 'div';
    if (isLeaderboardVisible) {
      TriviaCardComponent = TriviaLeaderboard;
    } else if (isAnswered && revealAnswer) {
      TriviaCardComponent = TriviaResult;
    } else {
      TriviaCardComponent = TriviaForm;
    }

    const styleClasses = classNames(classes.bg, {
      [classes.close]: hideTrivia,
      [classes.isNotFullScreen]: !playerIsFullscreen,
    });
    return (
      <MuiThemeProvider theme={muiTheme}>
        <div className={styleClasses}>
          <Slide direction="up" in={isVisible} mountOnEnter unmountOnExit>
            <Card className={classes.card}>
              <TriviaCardComponent onClose={this.handleClose} />
            </Card>
          </Slide>
        </div>
      </MuiThemeProvider>
    );
  }
}

export const TriviaComponent = withStyles(styles)(Trivia);
